import myfoot from './myfoot.vue'
import myhead from './myhead.vue'
import SsgMessagebox from './messagebox.vue'
import messagenewBox from './messagenewBox.vue'

import page from './page.vue'
import elTreeselect from './el-tree-select';
import addorginstaff from './addorginstaff'
import department from './department.vue'
import orgManagement from './orgManagement.vue'
import addorg from './addorg.vue'
import buttonfilter from './buttonfilter.vue'
import errorPrompt from './errorPrompt.vue'

const common = {
	install:function(Vue){
		Vue.component('filterdiv',buttonfilter)
		Vue.component('myfoot', myfoot)
		Vue.component('myhead', myhead)
		Vue.component('SsgMessagebox', SsgMessagebox)
		Vue.component('page',page)
		Vue.component('elTreeselect',elTreeselect)
		Vue.component('addorginstaff',addorginstaff)
		Vue.component('departmentss',department)
		Vue.component('orgManagement',orgManagement)
		Vue.component('addorg',addorg)
		Vue.component('messagenewBox',messagenewBox)
		Vue.component('errorPrompt',errorPrompt)







		
	}
}

export default common
